import {Component, Input, OnChanges, OnInit, signal, SimpleChanges, ViewChild} from '@angular/core';
import {EventTestFacade} from '../event/services/event-test-facade.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {EventRepository} from '../event/services/event-repository';
import {NgClass, NgStyle} from '@angular/common';
import * as dateFns from 'date-fns';
import {ConfirmationService} from 'primeng/api';
import {coalesce, FetchRequest} from '@abydos-angular/core';
import {ApplicationFacade} from '../rest-api/application/store/application.facade';
import {AuthFacade} from '@abydos-angular/rest-api';
import {BaseFormDialogComponent, DialogBodyDirective} from '@abydos-angular/form';
import {ApplicationEditedDataComponent} from '../application/edited-data/application-edited-data.component';
import {PayloadWithRequestId} from '@abydos-angular/store';
import {ApplicationVO} from '../rest-api/application/store/application.interfaces';
import {Tooltip} from 'primeng/tooltip';
import {Toast} from 'primeng/toast';

@Component({
    selector: 'app-fulfillment-list',
    imports: [
        ReactiveFormsModule,
        TableModule,
        NgClass,
        NgStyle,
        FormsModule,
        BaseFormDialogComponent,
        DialogBodyDirective,
        ApplicationEditedDataComponent,
        Tooltip,
        Toast,
    ],
    templateUrl: './fulfillment-list.component.html',
    standalone: true,
    styleUrl: './fulfillment-list.component.scss',
    providers: [EventTestFacade, EventRepository]
})
export class FulfillmentListComponent implements OnChanges {
    @ViewChild('dialog', {static: true}) dialog?: BaseFormDialogComponent;

    public selectedRow: any;
    applicationsWithDays: any = signal([]);
    @Input()
    selectedOption: any;
    completedHours?: number;
    oncomingHours?: number;

    constructor(private applicationFacade: ApplicationFacade,
                private authFacade: AuthFacade, private confirmationService: ConfirmationService) {
        setTimeout(() => {
            const request = new FetchRequest<any>();
            request.criteria = {
                baseCriteria: [
                    {fieldName: 'user.id', value: this.authFacade.currentUserInfo?.id, operator: 'equals'},
                    {fieldName: 'deleted', value: false, operator: 'equals'},
                    {fieldName: 'plannedStart', value: dateFns.startOfDay(new Date()), operator: this.selectedOption},
                ]
            }
            this.applicationFacade.list(request, result => {
                this.applicationsWithDays.set(this.addDayOfEvent(result.getData()).map((value: any) => {
                    return value;
                }))
                const element = document.getElementById('list-start');
                setTimeout(() => element?.scrollIntoView({behavior: 'smooth'}));
            })
        })
    }

    addDayOfEvent(applications: any) {
        return applications.map((application: any) => {
            const year = new Date(application.event.start).getFullYear()
            const month = new Date(application.event.start).getMonth()
            const day = new Date(application.event.start).getDate()
            return {...application, dayOfEvent: new Date(year, month, day)};
        })
    }

    viewApplication() {
        console.log(this.selectedRow)
        setTimeout(() => this.dialog?.showEditDialog(this.selectedRow?.id));
    }

    protected readonly dateFns = dateFns;

    editedDataSaved(payload: PayloadWithRequestId<ApplicationVO>) {
        this.refreshList();
        if (payload?.metadata?.saveAndNewInProgress) {
            // Ment és új van folyamatban, nincs mit csinálni
        } else {
            this.dialog!.closeDialog();
        }
    }

    refreshList() {
        const request = new FetchRequest<any>();
        request.criteria = {
            baseCriteria: [
                {fieldName: 'user.id', value: this.authFacade.currentUserInfo?.id, operator: 'equals'},
                {fieldName: 'deleted', value: false, operator: 'equals'},
                {fieldName: 'plannedStart', value: dateFns.startOfDay(new Date()), operator: this.selectedOption},
                // {fieldName: 'plannedStart', value: dateFns.startOfDay(new Date()), operator: 'lessOrEqual'},
            ]
        }
        this.applicationFacade.list(request, result => {
            this.applicationsWithDays.set(this.addDayOfEvent(result.getData()).map((value: any) => {
                return value;
            }))
            if (this.selectedOption === 'lessOrEqual') {
                this.completedHours = result.getData()!.filter((application: ApplicationVO) => application.fulfilled)
                    .map((application: ApplicationVO) => dateFns.differenceInHours(application.event?.end!, application.event?.start!, {roundingMethod: 'round'}))
                    .reduce((a: any, b: any) => a + b, 0)
            } else {
                this.oncomingHours = result.getData()!.map((application: ApplicationVO) => dateFns.differenceInHours(application.event?.end!, application.event?.start!))
                    .reduce((a: any, b: any) => a + b, 0)
            }
        })
    }

    doInput() {
        this.refreshList();
        return;
    }

    changesAvailable(event: any) {
        return dateFns.differenceInHours(event.start, new Date()) >= coalesce(event.activity.cancelHoursBeforeEvent, 48)
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('selectedOption' in changes) {
            this.refreshList();
        }
    }

    deleteApplication() {
        this.confirmationService.confirm({
            target: undefined,
            message: 'Biztosan törölni szeretné a jelentkezését a kiválasztott eseményre?',
            header: 'Megerősítés szükséges!',
            closable: true,
            closeOnEscape: true,
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: 'Mégse',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Törlés',
            },
            accept: () => {
                console.log(this.selectedRow)
                this.applicationFacade.removeWithCallback(this.selectedRow.id!, result => {
                    this.refreshList();
                });
            },
            reject: () => {

            },
        })
    }
}
